import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'

import { scrollToTargetForce } from '../scrolling';
import { classNames } from '../constants';

class ChapterContentView extends RytmWebflow.WebflowView {

  constructor(id) {
    super(id);
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container);
    this.initScrollTriggers();
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container);
  }
  /**
   * #######################
   * ### Scroll Triggers ###
   */
  initScrollTriggers = () => {
    this.initScrollTriggerContent();
    // forse scroll to first image
    gsap.to(this.container, {
      scrollTrigger: {
        trigger: this.container,
        start: () => {
          const wH = window.innerHeight;
          return `bottom ${ wH * .3 }px`;
        },
        // markers: true,
        onEnter: () => {
          scrollToTargetForce('.chapter-objects', {duration: .8, offset: 1});
        },
      }
    });
  }
  initScrollTriggerContent = () => {
    const opening = document.querySelector('.chapter-opening');
    if (!opening) return;
    // show chapter content
    gsap.set(this.container, { autoAlpha: 0 });
    gsap.to(this.container, {
      scrollTrigger: {
        toggleActions: "restart none none reverse",
        trigger: '.chapter-opening',
        start: 'center top',
        // markers: true,
      },
      autoAlpha: 1,
      duration: .6,
      delay: 0,
      ease: 'power2.inOut',
      onStart: () => {
        document.body.classList.add(classNames.CHAPTER_READY);
      }
    });
  }
  /**
   * ### End: Scroll Triggers ###
   * ############################
   */

}

export default ChapterContentView